import { Box, Typography } from '@mui/material'
import IconMoon from 'components/iconmoon'

interface BarItem {
  label: string
  percentage: number
  value?: string | number
  icon?: string
}

interface HorizontalBarListProps {
  data: BarItem[]
  colors: string[]
  showIcons?: boolean
  iconSize?: number
  gap?: number
}

const HorizontalBarList = ({
  data,
  colors,
  showIcons = false,
  iconSize = 18,
  gap = 2
}: HorizontalBarListProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap }}>
    {data.map((item, i) => {
      const color = colors[i % colors.length]
      return (
        <Box key={item.label}>
          <Box
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {showIcons && item.icon && (
                <IconMoon icon={item.icon} size={iconSize} color={color} />
              )}
              <Typography variant='body2' sx={{ fontSize: 13 }}>
                {item.label}
              </Typography>
            </Box>
            <Typography variant='body2' sx={{ fontSize: 13, fontWeight: 500, color }}>
              {item.value ?? `${item.percentage}%`}
            </Typography>
          </Box>
          <Box sx={{ height: 8, bgcolor: '#f0f0f0', borderRadius: 4, overflow: 'hidden' }}>
            <Box
              sx={{
                height: '100%',
                width: `${item.percentage}%`,
                bgcolor: color,
                borderRadius: 4,
                transition: 'width 0.4s ease'
              }}
            />
          </Box>
        </Box>
      )
    })}
  </Box>
)

export default HorizontalBarList
